import { useState } from "react";
import {
  AppShell,
  Navbar,
  Header,
  Text,
  MediaQuery,
  Burger,
  useMantineTheme,
  Breadcrumbs,
  Box,
} from "@mantine/core";
import { Outlet, Link } from "react-router-dom";

import { RequireAuth } from "features/backstage/auth";
import NavMenu from "./NavMenu";
import ToggleThemeBtn from "./ToggleThemeBtn";

import LogoTainan from "images/logo-tainan-3.svg";

const Layout = () => {
  const theme = useMantineTheme();

  const [opened, setOpened] = useState(false);

  return (
    <RequireAuth>
      <AppShell
        styles={{
          main: {
            background:
              theme.colorScheme === "dark"
                ? theme.colors.dark[8]
                : theme.colors.gray[0],
          },
        }}
        navbarOffsetBreakpoint="sm"
        asideOffsetBreakpoint="sm"
        fixed
        navbar={
          <Navbar
            p="md"
            hiddenBreakpoint="sm"
            hidden={!opened}
            width={{ sm: 200, lg: 300 }}
          >
            <NavMenu />
          </Navbar>
        }
        header={
          <Header height={70} p="md">
            <div
              style={{ display: "flex", alignItems: "center", height: "100%" }}
            >
              <MediaQuery largerThan="sm" styles={{ display: "none" }}>
                <Burger
                  opened={opened}
                  onClick={() => setOpened((o) => !o)}
                  size="sm"
                  color={theme.colors.gray[6]}
                  mr="xl"
                />
              </MediaQuery>
              <Box
                sx={() => ({
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                })}
              >
                <Text>
                  <Breadcrumbs>
                    <Text
                      variant="link"
                      component={Link}
                      to="/"
                      color="cyan"
                      underline={false}
                    >
                      <img
                        className="h-[43px] w-[222px] lg:h-[43px] lg:w-[222px]"
                        src={LogoTainan}
                        alt="臺南城市儀表板"
                        draggable="false"
                        />
                    </Text>
                    <Text>系統操作帳號權限管理</Text>
                  </Breadcrumbs>
                </Text>
                <ToggleThemeBtn></ToggleThemeBtn>
              </Box>
            </div>
          </Header>
        }
      >
        <Outlet />
      </AppShell>
    </RequireAuth>
  );
};

export default Layout;
